import { all, fork } from "redux-saga/effects";
import { formSagas } from "./Form/sagas";
import { relatorios } from "./Relatorios/sagas";

export function* rootSaga() {
  yield all([fork(relatorios), fork(formSagas)]);
}
